// This file was auto-generated by commondatabuilder.
// Please don't edit it.

export type BoroughChoice = "BROOKLYN"|"QUEENS"|"BRONX"|"MANHATTAN"|"STATEN_ISLAND";

export const BoroughChoices: BoroughChoice[] = [
  "BROOKLYN",
  "QUEENS",
  "BRONX",
  "MANHATTAN",
  "STATEN_ISLAND"
];

const BoroughChoiceSet: Set<String> = new Set(BoroughChoices);

export function isBoroughChoice(choice: string): choice is BoroughChoice {
  return BoroughChoiceSet.has(choice);
}

export type BoroughChoiceLabels = {
  [k in BoroughChoice]: string;
};

export function getBoroughChoiceLabels(): BoroughChoiceLabels {
  return {
    BROOKLYN: "Brooklyn",
    QUEENS: "Queens",
    BRONX: "Bronx",
    MANHATTAN: "Manhattan",
    STATEN_ISLAND: "Staten Island",
  };
}
